import React, { useState } from "react";
import {
    GET_FEEDBACK_META_ENDPOINT,
    GET_SUPPORT_TICKET_QUERY_META_ENDPOINT,
} from "../../constants/routes";
import { useContextState } from "../../context/ContextProvider";
import useNetwork from "../../hooks/useNetwork";
import Container from "../../shared/Container";
import Section from "../../shared/Section";
import LinedTab from "../../shared/ui/tab/LinedTab";
import ChatContainer from "./chat/ChatContainer";
import MemberDetails from "./sections/MemberDetails";
import ProfileCard from "./sections/ProfileCard";

let data = ["Users", "Support"];
const Profile = () => {
    const [active, setActive] = useState(0);
    const { state } = useContextState();

    const { data: meta } = useNetwork(GET_SUPPORT_TICKET_QUERY_META_ENDPOINT);

    const { data: membersData } = useNetwork(
        `/consumer/${state?.user?.plant?.plantId}/member`
    );

    const { data: feedbackMeta } = useNetwork(GET_FEEDBACK_META_ENDPOINT);

    return (
        <Section className=" bg-blue-700 lg:bg-white mb-0 pt-7 lg:pt-12 lg:h-screen lg:mb-0 xl:mb-0 2xl:mb-0">
            <div className="h-full lg:hidden">
                <Container>
                    <LinedTab
                        className="pb-0 mb-2.4 font-vietnam"
                        data={data}
                        activeTab={active}
                        inActiveClass="text-gray-370"
                        onClick={setActive}
                        activeClass="font-medium"
                    />
                </Container>

                {active === 0 ? (
                    <div className=" h-full">
                        <Container>
                            <ProfileCard
                                address={membersData?.data?.data?.address}
                            />
                        </Container>
                        <div className="bg-white rounded-t-2 py-4 mt-2.4  h-full pb-8">
                            <Container>
                                <MemberDetails
                                    members={
                                        membersData?.data?.data?.members || []
                                    }
                                />
                            </Container>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="bg-white h-screen rounded-t-2">
                            <ChatContainer
                                meta={meta}
                                feedbackMeta={feedbackMeta?.data?.tickets}
                            />
                        </div>
                    </>
                )}
            </div>

            <div className="hidden lg:block">
                <Container>
                    <div className="flex justify-between ">
                        <div className=" w-[55%]  2xl:w-[48%]">
                            <ProfileCard
                                address={membersData?.data?.data?.address}
                            />
                            <MemberDetails
                                members={membersData?.data?.data?.members || []}
                            />
                        </div>
                        <div className="w-[42%] 2xl:w-[48%]">
                            <ChatContainer
                                meta={meta}
                                feedbackMeta={feedbackMeta?.data?.tickets}
                            />
                        </div>
                    </div>
                </Container>
            </div>
        </Section>
    );
};

export default Profile;
